import axios from '@/utils/request';
// 获取公司列表数据
export const getEnterpriseList = (params) => {
    return axios.get('/system/enterprise/getEnterpriseList', {params})
}
// 获取公司详情
export const getEnterpriseInfo = (id) => {
    return axios.get(`/system/enterprise/getEnterpriseInfo/${id}`)
}